<div msScrolledToBottom scrollContext="document" *ngIf="grid$ | async as gridModel; else error" (scrollAtBottom)="loadMore()">
    <div class="grid-wrapper">
        <div class="grid-outer-title" [class.form-coupon-title]="isFormCoupon">{{ coupon.title }}</div>

        <ms-form-coupon-header *ngIf="isFormCoupon" [grid]="grid$" [mode]="form" (formSwitch)="onFormSwitch($event)"></ms-form-coupon-header>

        <ms-grid sortingTracking="Coupons" *ngIf="!couponType" [model]="gridModel" [tracking]="getTracking()" [hideTitle]="true"></ms-grid>

        <ms-coupon-grid
            sortingTracking="Coupons"
            *ngIf="couponType"
            [couponModel]="gridModel"
            [tracking]="getTracking()"
            [isTitleHide]="true"
            [couponType]="couponType"
            [hideMarketHeader]="!!couponType"
            [betDetails]="coupon.title"></ms-coupon-grid>

        <div class="grid-footer ms-active-highlight" *ngIf="hasMore()" (click)="loadMore()">
            <div [class.spinner-img]="loading">{{ sitecore.event.MoreEvents }}</div>
        </div>
    </div>
</div>
<div class="grid-footer-separator" *ngIf="hasMore()"></div>
<ng-template #error>
    <ms-error severity="info" *ngIf="!grid$" [links]="false" [message]="sitecore.coupons.noCoupons"></ms-error>
</ng-template>
